import React, { useEffect, useState } from 'react';
import styles from './LoginForm.module.scss';
import { useForm } from 'react-hook-form';
import Input from '../Input/Input';
import Button from '../Button/Button';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Loading from '../Loading/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { userLogin } from '../../redux/actions/user/userLogin';
import { toast } from 'react-toastify';
import Link from '../Link/Link';
import { userRegistration } from '../../redux/actions/user/userRegistration';
import { userResetPassword } from '../../redux/actions/user/userResetPassword';
import { resetUserLogin } from '../../redux/slices/user.slice';
const LoginForm = ({ title, type, className, isPage }) => {
  const form = useForm({ defaultValues: { email: '', password: '' } });
  const dispatch = useDispatch();
  const [status, setStatus] = useState('SIGN_IN');
  const {
    userLogin: { data: userLoginData, loading: userLoginLoading, error: userLoginError },
    userRegistration: { data: userRegistrationData, loading: userRegistrationLoading, error: userRegistrationError },
    userResetPassword: { data: userResetPasswordData, loading: userResetPasswordLoading, error: userResetPasswordError },
  } = useSelector((state) => state.user);

  useEffect(() => {
    form.reset();
  }, [status]);

  useEffect(() => {
    if (userRegistrationData) {
      setStatus('SUCCESS_SIGN_UP');
    }
  }, [userRegistrationData]);
  useEffect(() => {
    if (userResetPasswordData) {
      setStatus('SUCCESS_RESET_PASSWORD');
    }
  }, [userResetPasswordData]);

  const navigate = useNavigate();
  const onLogin = (data) => {
    dispatch(userLogin({ ...data, type }));
  };
  const onRegistration = (data) => {
    dispatch(userRegistration({ ...data }));
  };
  const onResetPassword = (data) => {
    dispatch(userResetPassword({ ...data }));
  };
  useEffect(() => {
    if (userLoginData) {
      localStorage.setItem('accessToken', userLoginData?.token);
      if (!isPage) {
        if (userLoginData?.type == 'USER') {
          navigate('/cabinet/user/dashboard');
        } else {
          navigate('/cabinet/partner/dashboard');
        }
      }
      // dispatch(resetUserLogin());
    }
  }, [userLoginData]);

  const signIn = () => {
    return (
      <>
        <div className={clsx(styles.title)}>Войти</div>
        <div className={clsx(styles.text)}>{type == 'USER' ? 'кабинет пользователя' : type == 'PARTNER' ? 'кабинет партнера' : ''}</div>
        <Input className={clsx(styles.inputEmail)} name="email" form={form} label="Почта" />
        <Input className={clsx(styles.inputPassword)} type="password" name="password" form={form} label="Пароль" />
        <Link
          noLine
          onClick={() => {
            setStatus('RESET_PASSWORD');
          }}>
          Забыли пароль?
        </Link>

        <Button className={clsx(styles.btn)} onClick={form.handleSubmit(onLogin)}>
          Войти
        </Button>
        {type == 'USER' && (
          <div className={clsx(styles.notAccount)}>
            Еще нет аккаунта ?{' '}
            <Link
              noLine
              onClick={() => {
                setStatus('SIGN_UP');
              }}>
              &nbsp;Зарегестрироваться
            </Link>
          </div>
        )}
        {userLoginLoading && <Loading />}
      </>
    );
  };

  const signUp = () => {
    return (
      <>
        <div className={clsx(styles.title)}>Регистрация</div>
        <div className={clsx(styles.text)}>регистрация пользователя</div>
        <Input className={clsx(styles.inputEmail)} name="email" form={form} label="Почта" />

        <Button className={clsx(styles.btn)} onClick={form.handleSubmit(onRegistration)}>
          Зарегестрироваться
        </Button>
        {type == 'USER' && (
          <div className={clsx(styles.notAccount)}>
            Уже есть аккаунт ?{' '}
            <Link
              noLine
              onClick={() => {
                setStatus('SIGN_IN');
              }}>
              &nbsp;Войти
            </Link>
          </div>
        )}
        {userRegistrationLoading && <Loading />}
      </>
    );
  };

  const successSignUp = () => {
    return (
      <div className={clsx(styles.success)}>
        <div className={clsx(styles.successIcon)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
        </div>
        <div className={clsx(styles.successTitle)}>Аккаунт зарегестрирован</div>
        <div className={clsx(styles.successText)}>На ваш email выслан пароль для входа в аккаунт </div>
        <Button
          className={clsx(styles.successBtn)}
          onClick={() => {
            setStatus('SIGN_IN');
          }}>
          Назад
        </Button>
      </div>
    );
  };

  const successResetPassword = () => {
    return (
      <div className={clsx(styles.success)}>
        <div className={clsx(styles.successIcon, styles.successIconReset)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-key">
            <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
          </svg>
        </div>
        <div className={clsx(styles.successTitle)}>Пароль сброшен</div>
        <div className={clsx(styles.successText)}>Новый пароль отправлен на вашу почту </div>
        <Button
          className={clsx(styles.successBtn)}
          onClick={() => {
            setStatus('SIGN_IN');
          }}>
          Назад
        </Button>
      </div>
    );
  };
  const resetPassword = () => {
    return (
      <>
        {' '}
        <div className={clsx(styles.title)}>Сброс пароля</div>
        <div className={clsx(styles.text)}>новый пароль придет на вашу почту</div>
        <Input className={clsx(styles.inputEmail)} name="email" form={form} label="Почта" />
        <Button className={clsx(styles.btn)} onClick={form.handleSubmit(onResetPassword)}>
          Сбросить пароль
        </Button>
        <div className={clsx(styles.notAccount)}>
          Вспомнили пароль ?
          <Link
            noLine
            onClick={() => {
              setStatus('SIGN_IN');
            }}>
            &nbsp;Войти
          </Link>
        </div>
        {userResetPasswordLoading && <Loading />}
      </>
    );
  };

  const getStep = () => {
    switch (status) {
      case 'SIGN_IN':
        return signIn();
      case 'SIGN_UP':
        return signUp();
      case 'SUCCESS_SIGN_UP':
        return successSignUp();
      case 'RESET_PASSWORD':
        return resetPassword();
      case 'SUCCESS_RESET_PASSWORD':
        return successResetPassword();

        break;

      default:
        break;
    }
  };

  return (
    <>
      <div className={clsx(styles.wrap, isPage && styles.wrapPage)}>{getStep()}</div>
    </>
  );
};

export default LoginForm;
